import { render } from "./OrientationWarning.vue?vue&type=template&id=3625b5c1&scoped=true"
import script from "./OrientationWarning.vue?vue&type=script&lang=js"
export * from "./OrientationWarning.vue?vue&type=script&lang=js"

import "./OrientationWarning.vue?vue&type=style&index=0&id=3625b5c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3625b5c1"]])

export default __exports__